<template>
  <div :class="['gallery', `gallery-${id}`]">
    <div :class="['gallery__pagination', `gallery-${id}__pagination`, {'g-hidden': slidesCount < 2}]"></div>
    <div class="gallery__swiper">
      <div class="gallery__col gallery__col_side">
        <div :class="['gallery__prev', `gallery-${id}__prev`]">
          <span>
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 0V5.5V11L0 5.5L11 0Z" fill="#292929"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="gallery__col gallery__col_center">
        <swiper ref="Swiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in dataArray" :key='index' :class="['gallery__item']">
            <div class="gallery__item-image">
              <img :src="item.image" :alt="currentText" v-bind="imageDisable ? { 'data-disabled-interactive': '' } : {}">
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="gallery__col gallery__col_side">
        <div :class="['gallery__next', `gallery-${id}__next`]">
          <span>
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0V5.5V11L11 5.5L0 0Z" fill="#292929"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="gallery__text" v-html="currentText"></div>
  </div>
</template>

<script>
export default {
  name: "SliderGallery",
  props: {
    id: {
      type: String,
      default: '0',
    },
    dataArray: {
      type: Array,
      default: () => {return []}
    },
    imageDisable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      slidesCount: 0,
      currentText: '',
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        watchOverflow: true,
        allowTouchMove: true,
        loopAdditionalSlides: 1,
        slideActiveClass: '_active',
        navigation: {
          prevEl: `.gallery-${this.id}__prev`,
          nextEl: `.gallery-${this.id}__next`,
          disabledClass: "_disabled"
        },
        pagination: {
          el: `.gallery-${this.id}__pagination`,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return current + '/' + total;
          }
        },
      }
    };
  },
  computed: {
  },
  mounted() {
    this.slidesCount = this.dataArray.length;
    this.currentSlide = this.$refs.Swiper.$swiper.realIndex;
    this.setCurrentSliderOptions();
    this.$refs.Swiper.$swiper.on('activeIndexChange', (swiper) => {
      this.currentSlide = parseInt(swiper.realIndex);
      this.setCurrentSliderOptions();
    })
  },
  methods: {
    setCurrentSliderOptions() {
      this.currentText = this.dataArray[this.currentSlide].text;
    },
  }
};
</script>

